module.exports = "<div class=\"main-content\">\r\n\t<app-navbar></app-navbar>\r\n\t<router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main